(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-reviews-mini"]) return;
  try {
    
  function compactCollectionStoreReviews(widget) {
    let attempts = 0;

    const applyCompactStyles = () => {
      attempts += 1;
      const root = widget.shadowRoot;

      if (!root) {
        if (attempts < 24) window.setTimeout(applyCompactStyles, 250);
        return;
      }

      if (!root.querySelector('#fbc-compact-collection-reviews')) {
        const style = document.createElement('style');
        style.id = 'fbc-compact-collection-reviews';
        style.textContent = `
          .gw-rv-main-slider-widget-wrapper,
          .gw-rv-main-slider-widget {
            height: auto !important;
            min-height: 0 !important;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
          }

          .gw-rv-main-slider-widget__title,
          .gw-rv-slider-item__image-wrapper {
            display: none !important;
          }

          .gw-rv-slider-item,
          .gw-rv-slider-item__btn,
          .gw-rv-slider-item__card,
          .gw-rv-slider-item__content,
          .gw-rv-slider-item__body {
            height: auto !important;
            min-height: 0 !important;
          }

          .gw-rv-slider-item__card {
            padding: 10px 12px !important;
          }

          .gw-rv-slider-item__content,
          .gw-rv-slider-item__body {
            flex: 0 0 auto !important;
            gap: 4px !important;
          }

          .gw-rv-slider-item__content {
            padding: 8px !important;
          }

          .gw-rv-slider-item__body p:last-child {
            display: -webkit-box !important;
            overflow: hidden !important;
            -webkit-box-orient: vertical !important;
            -webkit-line-clamp: 2 !important;
          }

          .gw-rv-slider-item__review-author {
            margin-bottom: 4px !important;
          }

          :host {
            display: block !important;
            height: auto !important;
            min-height: 0 !important;
          }

        `;
        root.appendChild(style);
      }
    };

    applyCompactStyles();
  }

  function initializeCollectionStoreReviews(root) {
    root.querySelectorAll('[data-fbc-collection-reviews]').forEach((section) => {
      const widget = section.querySelector('.gw-rv-reviews-slider-widget-placeholder');
      const sectionWrapper = section.closest('.shopify-section');
      const collectionBox = sectionWrapper?.nextElementSibling?.querySelector('.box');

      if (widget) compactCollectionStoreReviews(widget);
      if (collectionBox) {
        const topSpace = window.matchMedia('(max-width: 749px)').matches ? '24px' : '32px';
        collectionBox.style.setProperty('padding-top', topSpace, 'important');
      }
    });
  }

  initializeCollectionStoreReviews(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeCollectionStoreReviews(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-cart-content"]) return;
  try {
    
  let fbcCartFsaHsaMarkup = '';
  let fbcCartConfidenceMarkup = '';

  function cloneFreedomCartMarkup(markup) {
    if (!markup) return null;
    const holder = document.createElement('template');
    holder.innerHTML = markup.trim();
    return holder.content.firstElementChild;
  }

  function mountFreedomCartEnhancements() {
    let shell = document.querySelector('.fbc-cart-shell');
    if (!shell) {
      const refreshedCart = document.querySelector('.dbtfy-cart-page-container');
      if (!refreshedCart) return;
      shell = document.createElement('div');
      shell.className = 'fbc-cart-shell';
      refreshedCart.insertAdjacentElement('beforebegin', shell);
      shell.appendChild(refreshedCart);
    }

    const cartTitle = shell.querySelector('.page-title');
    if (cartTitle && !cartTitle.querySelector('.page-title__accent') && cartTitle.textContent.trim().toLowerCase() === 'your cart') {
      cartTitle.textContent = '';
      cartTitle.append('YOUR ');
      const titleAccent = document.createElement('span');
      titleAccent.className = 'page-title__accent';
      titleAccent.textContent = 'CART';
      cartTitle.appendChild(titleAccent);
    }

    const summaryFooter = shell.querySelector('.cart__right-item .card-footer');
    const template = shell.querySelector('#FbcCartConfidenceTemplate');
    if (template && !fbcCartConfidenceMarkup) fbcCartConfidenceMarkup = template.innerHTML;

    if (summaryFooter && !summaryFooter.querySelector('.fbc-cart-confidence')) {
      if (template) {
        summaryFooter.appendChild(template.content.cloneNode(true));
      } else {
        const confidencePanel = cloneFreedomCartMarkup(fbcCartConfidenceMarkup);
        if (confidencePanel) summaryFooter.appendChild(confidencePanel);
      }
    }

    const checkoutButton = shell.querySelector('[name="checkout"], .btn--checkout');
    const fsaHsaTemplate = shell.querySelector('#FbcCartFsaHsaTemplate');
    if (fsaHsaTemplate && !fbcCartFsaHsaMarkup) fbcCartFsaHsaMarkup = fsaHsaTemplate.innerHTML;
    if (checkoutButton && !shell.querySelector('.fbc-cart-fsa-hsa')) {
      const fsaHsaPanel = fsaHsaTemplate ? fsaHsaTemplate.content.firstElementChild.cloneNode(true) : cloneFreedomCartMarkup(fbcCartFsaHsaMarkup);
      if (fsaHsaPanel) checkoutButton.insertAdjacentElement('beforebegin', fsaHsaPanel);
    }
    if (checkoutButton && !/secure\s+checkout/i.test(checkoutButton.textContent)) {
      const textWalker = document.createTreeWalker(checkoutButton, NodeFilter.SHOW_TEXT);
      let checkoutTextNode = textWalker.nextNode();
      while (checkoutTextNode) {
        if (/check\s*out/i.test(checkoutTextNode.textContent)) {
          checkoutTextNode.textContent = checkoutTextNode.textContent.replace(/check\s*out/i, 'Secure Checkout');
        }
        checkoutTextNode = textWalker.nextNode();
      }
    }

    const cartProducts = shell.querySelector('.cart-products');
    let orderUpdatesSlot = shell.querySelector('.fbc-order-updates-slot');
    if (cartProducts && !orderUpdatesSlot) {
      orderUpdatesSlot = document.createElement('div');
      orderUpdatesSlot.className = 'fbc-order-updates-slot';
      cartProducts.insertAdjacentElement('afterend', orderUpdatesSlot);
    }

    const rechargeWrapper = document.querySelector('#rcsms-cart-widget, .rcsms-cart-widget__wrapper');

    if (rechargeWrapper) {
      const source = rechargeWrapper.closest('#rcsms-cart-widget') || rechargeWrapper;
      const rechargeContent = source.querySelector('.rcsms-cart-widget__wrapper');
      const rechargeIsActive = source.style.display !== 'none' && (!rechargeContent || rechargeContent.style.display !== 'none');
      source.classList.add('fbc-order-updates-row');
      source.classList.toggle('fbc-order-updates-row--active', rechargeIsActive);
      const smsTextWalker = document.createTreeWalker(source, NodeFilter.SHOW_TEXT);
      let smsTextNode = smsTextWalker.nextNode();
      while (smsTextNode) {
        smsTextNode.textContent = smsTextNode.textContent.replace(/Manage your orders via SMS/i, 'Get order updates via SMS');
        smsTextNode = smsTextWalker.nextNode();
      }
      if (orderUpdatesSlot && source.parentElement !== orderUpdatesSlot) {
        orderUpdatesSlot.appendChild(source);
      }
    }

    const orderUpdatesRow = shell.querySelector('.fbc-order-updates-row');
    if (orderUpdatesRow) {
      const rechargeInfoLeaf = Array.from(orderUpdatesRow.querySelectorAll('*'))
        .filter((element) => {
          const text = element.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
          return text.includes('cancel your subscription') && text.includes('schedule');
        })
        .sort((first, second) => first.textContent.length - second.textContent.length)
        [0];
      if (rechargeInfoLeaf) {
        orderUpdatesRow.querySelectorAll('.fbc-recharge-info').forEach((element) => {
          element.classList.remove('fbc-recharge-info');
        });
        let rechargeInfoPanel = rechargeInfoLeaf;
        while (rechargeInfoPanel.parentElement !== orderUpdatesRow) {
          const position = window.getComputedStyle(rechargeInfoPanel).position;
          if (position === 'absolute' || position === 'fixed') break;
          rechargeInfoPanel = rechargeInfoPanel.parentElement;
        }
        rechargeInfoPanel.classList.add('fbc-recharge-info');
      }
      if (!orderUpdatesRow.dataset.fbcRechargeLogoDisabled) {
        orderUpdatesRow.dataset.fbcRechargeLogoDisabled = 'true';
        orderUpdatesRow.addEventListener('click', function(event) {
          if (event.target.closest('input, label')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);
      }
    }

    return Boolean(shell.querySelector('.fbc-order-updates-row'));
  }

  document.addEventListener('DOMContentLoaded', mountFreedomCartEnhancements);
  document.addEventListener('shopify:section:load', mountFreedomCartEnhancements);
  document.addEventListener('cart:updated', mountFreedomCartEnhancements);
  mountFreedomCartEnhancements();

  if (!document.documentElement.dataset.fbcZipchatBound) {
    document.documentElement.dataset.fbcZipchatBound = 'true';
    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('[data-fbc-open-zipchat]');
      if (!trigger) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      let attempts = 0;
      const openZipchat = function() {
        if (window.Zipchat && typeof window.Zipchat.open === 'function') {
          window.Zipchat.open({ open: true });
          return;
        }
        attempts += 1;
        if (attempts < 20) window.setTimeout(openZipchat, 150);
      };
      openZipchat();
    }, true);
  }

  const freedomCartShell = document.querySelector('.fbc-cart-shell');
  if (freedomCartShell && !document.documentElement.dataset.fbcSubscriptionWatcherV2) {
    document.documentElement.dataset.fbcSubscriptionWatcherV2 = 'true';
    let subscriptionMountQueued = false;
    const subscriptionObserver = new MutationObserver((mutations) => {
      const rechargeChanged = mutations.some((mutation) => {
        if (mutation.type === 'attributes') {
          return mutation.target.matches('#rcsms-cart-widget, .rcsms-cart-widget__wrapper');
        }
        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return node.matches('#rcsms-cart-widget, .rcsms-cart-widget__wrapper') || node.querySelector('#rcsms-cart-widget, .rcsms-cart-widget__wrapper');
        });
      });
      const cartMarkupChanged = mutations.some((mutation) => {
        if (mutation.type !== 'childList') return false;
        if (mutation.target.nodeType === Node.ELEMENT_NODE && mutation.target.closest('.cart__right-item')) {
          return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
        }
        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return node.matches('.fbc-cart-shell, .dbtfy-cart-page-container, .cart__right-item, .cart__right-item .card-footer') || node.querySelector('.fbc-cart-shell, .dbtfy-cart-page-container, .cart__right-item, .cart__right-item .card-footer');
        });
      });
      if (!rechargeChanged && !cartMarkupChanged) return;
      if (subscriptionMountQueued) return;
      subscriptionMountQueued = true;
      window.requestAnimationFrame(() => {
        subscriptionMountQueued = false;
        mountFreedomCartEnhancements();
      });
    });
    subscriptionObserver.observe(document.body, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
  }

  if (freedomCartShell && !document.documentElement.dataset.fbcCartControlsWatcher) {
    document.documentElement.dataset.fbcCartControlsWatcher = 'true';
    const refreshAfterCartControl = function(event) {
      const cartProducts = event.target.closest('.cart-products');
      if (!cartProducts) return;
      const cartControl = event.target.closest('button, [role="button"], input[name^="updates"], select[name^="updates"]');
      if (!cartControl) return;
      [0, 150, 500, 1200, 2000, 3500, 5000].forEach(function(delay) {
        window.setTimeout(mountFreedomCartEnhancements, delay);
      });
    };
    document.addEventListener('click', refreshAfterCartControl, true);
    document.addEventListener('change', refreshAfterCartControl, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-frequently-bought"] && !Shopify.designMode) return;
  try {
    
  function initFrequentlyBought(section){
    if(!section||section.dataset.ready)return;
    if(!section.querySelector('[data-fbt-card]')){
      if(section.querySelector('.fbt__loading'))fetch(section.dataset.url).then(function(response){return response.text()}).then(function(text){var page=new DOMParser().parseFromString(text,'text/html');var replacement=page.querySelector('#'+section.id);if(replacement){section.replaceWith(replacement);initFrequentlyBought(document.querySelector('#'+replacement.id))}});
      return;
    }
    section.dataset.ready='true';
    var formatMoney=function(cents){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify&&Shopify.currency?Shopify.currency.active:'USD'}).format(cents/100)};
    var status=section.querySelector('[data-fbt-status]');
    section.querySelectorAll('[data-fbt-card]').forEach(function(card){
      var select=card.querySelector('[data-fbt-variant]');
      var price=card.querySelector('[data-fbt-price]');
      var add=card.querySelector('[data-fbt-add]');
      select.addEventListener('change',function(){var option=select.options[select.selectedIndex];var image=card.querySelector('img');price.textContent=formatMoney(Number(option.dataset.price));if(image&&option.dataset.image){image.src=option.dataset.image;image.srcset='';image.alt=option.dataset.imageAlt||option.text}add.disabled=option.disabled});
      add.addEventListener('click',function(){
        if(add.disabled)return;
        add.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:1}]})}).then(function(response){if(!response.ok)throw new Error('Cart add failed');return response.json()}).then(function(){status.textContent='Added to your cart';add.textContent='Added ✓';document.dispatchEvent(new CustomEvent('cart:updated'))}).catch(function(){status.textContent='Could not add this item. Please try again.';add.disabled=false});
      });
    });
  }
  function observeFrequentlyBought(section){
    if(!section||section.dataset.fbtObserved==='true')return;
    section.dataset.fbtObserved='true';
    if(!('IntersectionObserver' in window)){initFrequentlyBought(section);return}
    var observer=new IntersectionObserver(function(entries){if(!entries[0].isIntersecting)return;observer.disconnect();initFrequentlyBought(section)},{rootMargin:'500px 0px'});
    observer.observe(section);
  }
  document.querySelectorAll('[data-fbt]').forEach(observeFrequentlyBought);
  document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-fbt]').forEach(observeFrequentlyBought)});
  document.addEventListener('shopify:section:load',function(event){var section=event.target.querySelector('[data-fbt]');if(section)observeFrequentlyBought(section)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-protection-builder"] && !Shopify.designMode) return;
  try {
    
  function mountDesktopFrequentlyBought(root){var slot=root&&root.querySelector('[data-desktop-fbt-slot]');var section=document.querySelector('[data-fbt]');if(!slot||!section)return;if(!slot._fbtPlaceholder){slot._fbtPlaceholder=document.createComment('frequently-bought-position');section.parentNode.insertBefore(slot._fbtPlaceholder,section)}if(window.matchMedia('(min-width: 900px)').matches){if(section.parentElement!==slot)slot.appendChild(section)}else if(slot._fbtPlaceholder.parentNode&&section.parentElement===slot){slot._fbtPlaceholder.parentNode.insertBefore(section,slot._fbtPlaceholder.nextSibling)}}
  function initProtectionBuilder(root){
    if(!root||root.dataset.pbInitialized==='true')return;
    root.dataset.pbInitialized='true';
    var variants=JSON.parse(root.querySelector('[data-variants]').textContent);
    var sellingPlanPrices=JSON.parse(root.querySelector('[data-selling-plan-prices]').textContent||'{}');
    var optionInputs=Array.from(root.querySelectorAll('[data-option-position]'));
    var idInput=root.querySelector('[data-variant-id]');
    var price=root.querySelector('[data-price]');
    var compare=root.querySelector('[data-compare]');
    var buttonPrice=root.querySelector('[data-button-price]');
    var summaryPrice=root.querySelector('[data-summary-price]');
    var selectionSummary=root.querySelector('[data-selection-summary]');
    var previewImage=root.querySelector('[data-selected-preview-image]');
    var selectedColor=root.querySelector('[data-selected-color]');
    var button=root.querySelector('[data-add]');
    var label=root.querySelector('[data-add-label]');
    var money=function(cents){return window.Shopify&&Shopify.formatMoney?Shopify.formatMoney(cents):'$'+(cents/100).toFixed(2)};
    var activeVariant;
    var update=function(){
      var selected=Array.from(root.querySelectorAll('[data-option-position]:checked')).sort(function(a,b){return Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition)}).map(function(input){return input.value});
      var variant=variants.find(function(item){return item.options.every(function(value,index){return value===selected[index]})});
      if(!variant)return;
      activeVariant=variant;
      idInput.value=variant.id;
      price.textContent=money(variant.price);
      summaryPrice.textContent=money(variant.price);
      selectionSummary.textContent=variant.title;
      if(selectedColor)selectedColor.textContent=variant.option1;
      if(previewImage&&variant.featured_image&&variant.featured_image.src){previewImage.src=variant.featured_image.src;previewImage.srcset='';previewImage.alt=variant.option1}
      if(variant.compare_at_price&&variant.compare_at_price>variant.price){compare.textContent=money(variant.compare_at_price);compare.hidden=false}else{compare.hidden=true}
      button.disabled=!variant.available;
      label.textContent=variant.available?root.dataset.addLabel:root.dataset.soldOutLabel;
      if(variant.featured_media){
        var target=root.querySelector('[data-media-id="'+variant.featured_media.id+'"]');
        if(target){
          root.querySelectorAll('.pb__media,.pb__thumb').forEach(function(el){el.classList.remove('is-active')});
          target.classList.add('is-active');
          var thumb=root.querySelector('[data-target-media="'+variant.featured_media.id+'"]');
          if(thumb)thumb.classList.add('is-active');
          var targetImage=target.querySelector('img');
          if(previewImage&&!variant.featured_image&&targetImage){previewImage.src=targetImage.currentSrc||targetImage.src;previewImage.srcset='';previewImage.alt=variant.option1}
        }
      }
      history.replaceState({},'',location.pathname+'?variant='+variant.id)
      updatePurchaseDisplay();
    };
    optionInputs.forEach(function(input){input.addEventListener('change',update)});
    root.querySelectorAll('[data-target-media]').forEach(function(thumb){thumb.addEventListener('click',function(){var target=root.querySelector('[data-media-id="'+thumb.dataset.targetMedia+'"]');if(!target)return;root.querySelectorAll('.pb__media,.pb__thumb').forEach(function(el){el.classList.remove('is-active')});target.classList.add('is-active');thumb.classList.add('is-active')})});
    var galleryStage=root.querySelector('.pb__stage');
    var galleryMedia=Array.from(root.querySelectorAll('.pb__media'));
    var galleryThumbs=Array.from(root.querySelectorAll('[data-target-media]'));
    function activateGalleryMedia(index){
      if(!galleryMedia.length)return;
      var normalized=(index+galleryMedia.length)%galleryMedia.length;
      galleryMedia.forEach(function(media,itemIndex){media.classList.toggle('is-active',itemIndex===normalized)});
      galleryThumbs.forEach(function(thumb,itemIndex){
        var selected=itemIndex===normalized;
        thumb.classList.toggle('is-active',selected);
        thumb.setAttribute('aria-current',selected?'true':'false')
      });
      var activeThumb=galleryThumbs[normalized];
      if(activeThumb)activeThumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'})
    }
    function activeGalleryIndex(){
      var index=galleryMedia.findIndex(function(media){return media.classList.contains('is-active')});
      return index<0?0:index
    }
    if(galleryStage&&galleryMedia.length>1){
      var swipeStartX=0;
      var swipeStartY=0;
      var swipeTracking=false;
      var suppressGalleryClick=false;
      galleryStage.addEventListener('click',function(event){
        if(!suppressGalleryClick)return;
        event.preventDefault();
        event.stopPropagation();
        suppressGalleryClick=false
      },true);
      galleryStage.addEventListener('touchstart',function(event){
        if(event.touches.length!==1||event.target.closest('iframe,model-viewer'))return;
        swipeStartX=event.touches[0].clientX;
        swipeStartY=event.touches[0].clientY;
        swipeTracking=true
      },{passive:true});
      galleryStage.addEventListener('touchend',function(event){
        if(!swipeTracking||!event.changedTouches.length)return;
        swipeTracking=false;
        var deltaX=event.changedTouches[0].clientX-swipeStartX;
        var deltaY=event.changedTouches[0].clientY-swipeStartY;
        if(Math.abs(deltaX)<45||Math.abs(deltaX)<=Math.abs(deltaY))return;
        suppressGalleryClick=true;
        window.setTimeout(function(){suppressGalleryClick=false},350);
        activateGalleryMedia(activeGalleryIndex()+(deltaX<0?1:-1))
      },{passive:true});
      galleryStage.addEventListener('touchcancel',function(){swipeTracking=false},{passive:true})
    }
    root.querySelectorAll('[data-external-video]').forEach(function(videoButton){videoButton.addEventListener('click',function(){if(videoButton.dataset.loaded==='true')return;var frame=document.createElement('iframe');frame.src=videoButton.dataset.videoSrc;frame.title=videoButton.getAttribute('aria-label')||document.title;frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;videoButton.dataset.loaded='true';videoButton.replaceChildren(frame)})});
    root.querySelectorAll('.pb__details iframe[data-youtube-src]').forEach(function(sourceFrame){var source=sourceFrame.dataset.youtubeSrc;var videoId=(source.split('/embed/')[1]||'').split('?')[0];var button=document.createElement('button');button.type='button';button.className='pb__external-video';button.setAttribute('aria-label',sourceFrame.title||document.title);var image=document.createElement('img');image.src='https://i.ytimg.com/vi/'+videoId+'/hqdefault.jpg';image.alt='';image.loading='lazy';var play=document.createElement('span');play.className='pb__external-video-play';play.setAttribute('aria-hidden','true');play.textContent='▶';button.append(image,play);button.addEventListener('click',function(){var frame=document.createElement('iframe');frame.src=source+(source.includes('?')?'&':'?')+'autoplay=1';frame.title=button.getAttribute('aria-label');frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;button.replaceWith(frame)});sourceFrame.replaceWith(button)});
    var quantity=root.querySelector('[name="quantity"]');
    root.querySelector('[data-quantity-minus]').addEventListener('click',function(){quantity.value=Math.max(1,Number(quantity.value||1)-1);updatePurchaseDisplay()});
    root.querySelector('[data-quantity-plus]').addEventListener('click',function(){quantity.value=Number(quantity.value||1)+1;updatePurchaseDisplay()});
    quantity.addEventListener('change',updatePurchaseDisplay);
    root.querySelectorAll('[data-open-product-details]').forEach(function(detailsButton){detailsButton.addEventListener('click',function(){var details=root.querySelector('[data-product-details]');if(!details)return;details.open=true;details.scrollIntoView({behavior:'smooth',block:'start'})})});
    root.querySelectorAll('[data-open-zipchat]').forEach(function(supportButton){supportButton.addEventListener('click',function(){var questions=document.querySelector('#product-tab-text_xB8hdx');if(!questions)return;var header=questions.querySelector('.tab-header');if(header&&!header.classList.contains('active'))header.click();questions.scrollIntoView({behavior:'smooth',block:'center'})})});
    var addon=root.querySelector('[data-addon]');
    if(addon){
      var addonVariants=JSON.parse(addon.dataset.addonVariants);
      var addonToggle=addon.querySelector('[data-addon-toggle]');
      var addonSelect=addon.querySelector('[data-addon-variant]');
      var addonPrice=addon.querySelector('[data-addon-price]');
      var addonSelected=addon.querySelector('[data-addon-selected]');
      var addonCards=Array.from(addon.querySelectorAll('[data-addon-card]'));
      addonSelect.addEventListener('change',function(){var addonVariant=addonVariants.find(function(item){return String(item.id)===addonSelect.value});if(!addonVariant)return;addonPrice.textContent=money(addonVariant.price);if(addonSelected)addonSelected.textContent=addonVariant.title;addonCards.forEach(function(card){var selected=card.dataset.addonVariantId===addonSelect.value;card.classList.toggle('is-selected',selected);card.setAttribute('aria-pressed',selected?'true':'false')})});
      addonCards.forEach(function(card){card.addEventListener('click',function(){addonSelect.value=card.dataset.addonVariantId;addonSelect.dispatchEvent(new Event('change',{bubbles:true}))})});
      addonToggle.addEventListener('change',updatePurchaseDisplay);
      addonSelect.addEventListener('change',updatePurchaseDisplay);
    }
    var productForm=root.querySelector('.pb__form');
    function getSelectedSellingPlan(){var sellingPlanField=productForm.querySelector('[name="selling_plan"]');if(sellingPlanField&&sellingPlanField.value)return sellingPlanField.value;var rechargeSubscribe=productForm.querySelector('.rc_widget__option__input--subsave:checked,input[value="subsave"]:checked');if(!rechargeSubscribe)return'';var rechargePlanSelect=productForm.querySelector('.rc-selling-plans__dropdown,select[id^="selling_plan_"]');return rechargePlanSelect?rechargePlanSelect.value:''}
    function getMainUnitPrice(mainVariant){var sellingPlanValue=getSelectedSellingPlan();var prices=sellingPlanPrices[String(mainVariant.id)]||{};return sellingPlanValue&&prices[String(sellingPlanValue)]!==undefined?Number(prices[String(sellingPlanValue)]):Number(mainVariant.price)}
    function getMainTotal(){var mainVariant=activeVariant||variants.find(function(item){return String(item.id)===idInput.value});if(!mainVariant)return 0;return getMainUnitPrice(mainVariant)*Math.max(1,Number(quantity.value||1))}
    function getPurchaseTotal(){var total=getMainTotal();if(addon&&addonToggle.checked){var selectedAddon=addonVariants.find(function(item){return String(item.id)===addonSelect.value});if(selectedAddon)total+=Number(selectedAddon.price)}return total}
    function updatePurchaseDisplay(){summaryPrice.textContent=money(getMainTotal());buttonPrice.textContent=money(getPurchaseTotal());updateRewards()}
    function bindSubscriptionControls(){var boundAny=false;productForm.querySelectorAll('[name="selling_plan"],input[name^="selling_plan_"],.rc-selling-plans__dropdown,select[id^="selling_plan_"]').forEach(function(control){if(control.dataset.pbPriceBound==='true')return;control.dataset.pbPriceBound='true';control.addEventListener('change',updatePurchaseDisplay);boundAny=true});if(boundAny)updatePurchaseDisplay()}
    new MutationObserver(bindSubscriptionControls).observe(productForm,{childList:true,subtree:true});
    bindSubscriptionControls();
    var isAdding=false;
    function restoreAfterHistoryNavigation(){isAdding=false;update()}
    window.addEventListener('pageshow',function(event){var navigation=window.performance&&window.performance.getEntriesByType?window.performance.getEntriesByType('navigation')[0]:null;if(event.persisted||(navigation&&navigation.type==='back_forward')){window.requestAnimationFrame(restoreAfterHistoryNavigation);window.setTimeout(restoreAfterHistoryNavigation,250)}});
    document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible')window.setTimeout(restoreAfterHistoryNavigation,0)});
    productForm.addEventListener('submit',function(event){
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if(isAdding)return;
      isAdding=true;
      button.disabled=true;
      var mainItem={id:Number(idInput.value),quantity:Math.max(1,Number(quantity.value||1))};var sellingPlanValue=getSelectedSellingPlan();if(sellingPlanValue)mainItem.selling_plan=Number(sellingPlanValue);var items=[mainItem];
      if(addon&&addonToggle.checked)items.push({id:Number(addonSelect.value),quantity:1,properties:{"_PDP add-on":"Yes","_PDP source product":root.dataset.productTitle||"","_PDP source handle":root.dataset.productHandle||""}});
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})}).then(function(response){if(!response.ok)throw new Error('Cart add failed');return response.json()}).then(function(){window.location.href='/cart'}).catch(function(){isAdding=false;button.disabled=false});
    },true);
    function updateRewards(){var rewards=root.querySelector('[data-rewards]');if(!rewards)return;var mainVariant=activeVariant||variants.find(function(item){return String(item.id)===idInput.value});if(!mainVariant)return;var projected=Number(rewards.dataset.cartTotal||0);var shippingGoal=Number(rewards.dataset.shippingGoal||0);var giftGoal=Number(rewards.dataset.giftGoal||0);var maximum=Math.max(shippingGoal,giftGoal);var percent=maximum?Math.min(100,Math.round(projected/maximum*100)):0;var visualPercent=Math.max(10,percent);var fill=rewards.querySelector('[data-rewards-fill]');var track=rewards.querySelector('[data-rewards-track]');fill.style.width=visualPercent+'%';track.setAttribute('aria-valuenow',String(percent));var shippingMarker=rewards.querySelector('[data-shipping-marker]');shippingMarker.style.left=Math.min(100,shippingGoal/maximum*100)+'%';var giftMarker=rewards.querySelector('[data-gift-marker]');if(giftMarker)giftMarker.style.left=Math.min(100,giftGoal/maximum*100)+'%';var giftUnlocked=giftGoal>0&&projected>=giftGoal;var shippingUnlocked=projected>=shippingGoal;var giftStatus=giftUnlocked?'<span class="pb__reward-status is-unlocked"><b>✓ Free Gift Unlocked</b></span>':'<span class="pb__reward-status"><b>'+money(Math.max(0,giftGoal-projected))+'</b> to Free Gift</span>';var dhlMark='<span class="pb__dhl-mark" aria-hidden="true"><svg viewBox="0 0 38 14" focusable="false"><rect width="38" height="14" rx="2" fill="#ffcc00"/><text x="19" y="10.5" text-anchor="middle" fill="#d40511" font-size="9" font-family="Arial,sans-serif" font-style="italic" font-weight="900">DHL</text></svg></span><span class="visually-hidden">DHL</span>';var shippingName=shippingGoal>3000?'Free '+dhlMark+' Shipping':'Free Shipping';var shippingStatus=shippingUnlocked?'<span class="pb__reward-status is-unlocked"><b>✓ '+shippingName+' Unlocked</b></span>':'<span class="pb__reward-status"><b>'+money(Math.max(0,shippingGoal-projected))+'</b> to '+shippingName+'</span>';rewards.querySelector('[data-rewards-message]').innerHTML=shippingGoal<giftGoal?shippingStatus+giftStatus:giftStatus+shippingStatus}
    document.addEventListener('cart:updated',function(event){var cart=event.detail&&event.detail.cart;var rewards=root.querySelector('[data-rewards]');if(cart&&rewards){rewards.dataset.cartTotal=cart.total_price;updateRewards()}});
    updatePurchaseDisplay();
  }
  function initAllProtectionBuilders(scope){(scope||document).querySelectorAll('[id^="ProtectionBuilder-"]').forEach(initProtectionBuilder)}
  initAllProtectionBuilders(document);
  document.addEventListener('DOMContentLoaded',function(){initAllProtectionBuilders(document);document.querySelectorAll('[id^="ProtectionBuilder-"]').forEach(function(root){mountDesktopFrequentlyBought(root);if(root.dataset.fbtResizeBound!=='true'){root.dataset.fbtResizeBound='true';window.addEventListener('resize',function(){mountDesktopFrequentlyBought(root)})}})});
  document.addEventListener('shopify:section:load',function(event){initAllProtectionBuilders(event.target)});

  } catch(e) { console.error(e); }
})();
})();
